import type { PermissionRole } from '@dealstack/shared/lib/common/fineGrainedAuthorization/permissions';

export type AddDefaultMemberInput = {
	firstName: string;
	lastName: string;
	email: string;
	role: PermissionRole;
};

export enum DefaultMemberScope {
	DEAL = 'DEAL',
	PROGRAMME = 'PROGRAMME',
}

export type DefaultMemberTableLabels = {
	name: string;
	search: string;
	role: string;
	remove: string;
};
